import { LiveIcon, PhoneIcon, WhatsAppIcon, CustomerIcon, RatingIcon, TrustShieldIcon } from '../../icons/icons'
import './Hero.css'

export default function Hero() {

  return (
    <section className="hero">
      <picture>
        <source media="(max-width: 768px)" srcSet="/assets/resp-hero-banner.png" />
        <img
          className="hero__bg"
          src="/assets/hero-banner.jpg"
          alt=""
        />
      </picture>
      <div className="hero__overlay" />

      {/* Desktop-only view container */}
      <div className="hero__content hero__content--desktop">
        <div className="hero__text-col">
          <div className="hero__text-group">
            <div className="hero__live-badge">
              <LiveIcon />
              <span>IN-PERSON STUDIO YOGA CLASSES</span>
            </div>
            <h1 className="hero__heading">
              <span className="hero__heading--white">Lose </span>
              <span className="hero__heading--gold">Weight</span>
              <span className="hero__heading--white">, Improve </span>
              <span className="hero__heading--gold">Mobility</span>
              <span className="hero__heading--white">, Feel More </span>
              <span className="hero__heading--gold">Balanced</span>
            </h1>
          </div>

          <div className="hero__cta-group">
            <p className="hero__description">
              Bharat Thakur's Artistic Yoga has helped people across UAE improve their health, reduce weight naturally, increase mobility, and build lasting strength.
            </p>
            <div className="hero__buttons">
              <a href="tel:971585759017" className="btn-primary" style={{ textDecoration: 'none' }}>
                <PhoneIcon />
                <span>585759017</span>
              </a>
              <a href="https://wa.me/971585759017" className="btn-dark" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        {/* Desktop-only stats card */}
        <div className="hero__stats-card hero__stats-card--desktop">
          <div className="hero__stat hero__stat--bordered">
            <span className="hero__stat-number">25+</span>
            <span className="hero__stat-label">Years Experience</span>
          </div>
          <div className="hero__stat hero__stat--bordered">
            <span className="hero__stat-number">218,466</span>
            <span className="hero__stat-label">Happy Customers</span>
          </div>
          <div className="hero__stat">
            <span className="hero__stat-number">4.5+</span>
            <span className="hero__stat-label">Google Rating</span>
          </div>
        </div>
      </div>

      {/* Mobile-only view container */}
      <div className="hero__content hero__content--mobile">
        <div className="hero__top">
          <div className="hero__text-group">
            <div className="hero__live-badge">
              <LiveIcon />
              <span>IN-PERSON STUDIO YOGA CLASSES</span>
            </div>
            <h1 className="hero__heading">
              <span className="hero__heading--white">Lose </span>
              <span className="hero__heading--gold">Weight</span>
              <span className="hero__heading--white">,</span>
              <br />
              <span className="hero__heading--white">Improve </span>
              <span className="hero__heading--gold">Mobility</span>
              <span className="hero__heading--white">,</span>
              <br />
              <span className="hero__heading--white">Feel More </span>
              <span className="hero__heading--gold">Balanced</span>
            </h1>
            <div className="hero__divider hero__divider--mobile" />
            <p className="hero__tagline hero__tagline--mobile">
              Expert guidance. Holistic practices. <br />
              Real transformation.
            </p>
          </div>

          {/* Mobile-only stats card */}
          <div className="hero__stats-card hero__stats-card--mobile">
            <div className="hero__stat hero__stat--bordered">
              <img
                className="hero__stat-icon"
                src="/assets/champion.svg"
                alt=""
              />
              <span className="hero__stat-number">25+</span>
              <span className="hero__stat-label">YEARS<br />EXPERIENCE</span>
            </div>
            <div className="hero__stat hero__stat--bordered">
              <CustomerIcon />
              <span className="hero__stat-number">218,446</span>
              <span className="hero__stat-label">HAPPY<br />CUSTOMERS</span>
            </div>
            <div className="hero__stat">
              <RatingIcon />
              <span className="hero__stat-number">4.5+</span>
              <span className="hero__stat-label">GOOGLE<br />RATING</span>
            </div>
          </div>
        </div>

        <div className="hero__cta-group hero__cta-group--mobile">
          <p className="hero__description">
            Bharat Thakur's Artistic Yoga has helped people across UAE improve their health, reduce weight naturally, increase mobility, and build lasting strength.
          </p>
          <div className="hero__buttons">
            <a href="tel:971585759017" className="btn-primary" style={{ textDecoration: 'none' }}>
              <PhoneIcon />
              <span>585759017</span>
            </a>
            <a href="https://wa.me/971585759017" className="btn-dark" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <WhatsAppIcon />
              <span>WhatsApp</span>
            </a>
          </div>
          <div className="hero__trust hero__trust--mobile">
            <TrustShieldIcon />
            <span>Trusted by thousands since 1999</span>
          </div>
        </div>
      </div>
    </section>
  )
}
